<div class="signup_main h-100">
    <div class="abstractCircleOne"></div>
    <div class="abstractCircleTwo"></div>

    <div class="signup_steps">
        <picture class="signup_steps_left second-image">
            <source srcset="images/signup/logo.png" media="(max-width: 980px)">
            <source srcset="images/signup/teem-landing.png">
            <img src="images/signup/teem-landing.png" alt="teem-landing" loading="lazy">
        </picture>
        <div class="signup_steps_right m-0">
            <a href="/login" class="back_to_step">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M10.7304 20.3118C10.4304 20.6118 10.0235 20.7803 9.59922 20.7803C9.17496 20.7803 8.76806 20.6118 8.46802 20.3118L1.26802 13.1118C0.968065 12.8118 0.799561 12.4049 0.799561 11.9806C0.799561 11.5564 0.968065 11.1495 1.26802 10.8494L8.46802 3.64942C8.76978 3.35796 9.17395 3.19669 9.59346 3.20034C10.013 3.20398 10.4143 3.37225 10.7109 3.66891C11.0076 3.96556 11.1759 4.36686 11.1795 4.78637C11.1831 5.20589 11.0219 5.61005 10.7304 5.91181L6.39922 10.3806L21.5992 10.3806C22.0236 10.3806 22.4305 10.5492 22.7306 10.8492C23.0306 11.1493 23.1992 11.5563 23.1992 11.9806C23.1992 12.405 23.0306 12.8119 22.7306 13.112C22.4305 13.412 22.0236 13.5806 21.5992 13.5806L6.39922 13.5806L10.7304 18.0494C11.0304 18.3495 11.1989 18.7564 11.1989 19.1806C11.1989 19.6049 11.0304 20.0118 10.7304 20.3118Z" fill="#1AACD9" />
                </svg>
                <ng-container i18n="@@common.back">Back to Log In</ng-container>
            </a>
            <div class="signup_steps_container">
                <div *ngIf="step === 1" class="signup_step">
                    <h2 i18n="@@signup.forgot_password">Forgot password?</h2>
                    <span i18n="@@forgot.no_worries_will_send_you_reset_intructions">No worries, we’ll send you reset instructions</span>

                    <form [formGroup]="forgotPasswordForm" class="create_form gap-4">
                        <div>
                            <label for="email" i18n="@@forgot.enter_your_email">Enter your email</label>
                            <input formControlName="email" type="email" id="email" required>
                            <div *ngIf="forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.invalid">
                                <small class="error" *ngIf="forgotPasswordForm.get('email')?.errors?.required" i18n="@@error.required.email">Email is required</small>
                                <small class="error" *ngIf="forgotPasswordForm.get('email')?.errors?.email" i18n="@@error.valid_email">Please enter valid email address</small>
                            </div>
                        </div>
                        
                        <button 
                            type="button" 
                            class="signUpBtn nextSignUpStep" 
                            [disabled]="!isFormValid()"
                            (click)="nextStep()"
                            i18n="@@forgot.reset_password"
                        >
                            Reset password
                        </button>
                    </form>
                    <div class="anotherVarContainer">
                        <div class="line"></div>
                        <span i18n="@@signup.don_t_have_account">Don’t have an account?</span>
                        <div class="line"></div>
                    </div>
                    <a class="logInBtn" href="/signup" i18n="@@signup.signup">Sign Up</a>
                </div>
                <div *ngIf="step === 2" class="signup_step">
                    <h2 i18n="@@forgot.password_reset">Password reset</h2>
                    <span>
                        <ng-container i18n="@@signup.enter_code_we_send_you">Enter the code we sent you to </ng-container>
                        <strong class="email-display"> {{ forgotPasswordForm.get('email')?.value }}</strong>
                    </span>
                    <form [formGroup]="otpForm" class="otp_form">
                        <div class="otp_form_inputs_container">
                            <input *ngFor="let control of otpControls; let i = index" type="text" maxlength="1" class="otp-input" [formControlName]="i" (input)="focusNext($event, i)" />
                        </div>
                        <button 
                            class="signUpBtn nextSignUpStep" 
                            [disabled]="!otpForm.valid" 
                            type="button" 
                            (click)="verifyOTP()"
                            i18n="@@signup.verify_proceed"
                        >
                            Verify & Proceed
                        </button>
                    </form>
                    <div class="anotherVarContainer">
                        <div class="line"></div>
                        <span i18n="@@signup.dont_receive_code">Didn’t receive the code?</span>
                        <div class="line"></div>
                    </div>
                    <button class="logInBtn" (click)="resendOTP()" [disabled]="resendTimer > 0">
                        <ng-container *ngIf="resendTimer > 0; else resendCode" i18n="@@signup.resend_code_in">
                            Resend code in {{ resendTimer }}
                        </ng-container>
                        <ng-template i18n="@@signup.resend_code" #resendCode>
                            Resend code
                        </ng-template>
                    </button>
                </div>
                <div class="signup_step" *ngIf="step === 3">
                    <h2 class="m-0" i18n="@@forgot.password_reset">Password reset</h2>
                    <form [formGroup]="forgotPasswordForm" class="create_form mb-0" action="">
                        <div class="password_contaier">
                            <label for="password" i18n="@@forgot.enter_new_password">Enter New Password</label>
                            <input formControlName="password" [type]="showPassword.password ? 'text' : 'password'" autocomplete="new-password" required>
                            <img class="eye-toggle eye-open" loading="lazy" src="./images/signup/eye-open.png" alt="Open eye" *ngIf="!showPassword.password" (click)="togglePasswordVisibility('password')">
                            <img class="eye-toggle eye-closed" loading="lazy" src="./images/signup/eye-closed.png" alt="Closed eye" *ngIf="showPassword.password" (click)="togglePasswordVisibility('password')">
                            <div *ngIf="forgotPasswordForm.get('password').dirty && forgotPasswordForm.get('password')?.errors">
                                <small class="error" *ngIf="forgotPasswordForm.get('password')?.errors?.required" i18n="@@error.required.password">Password is required</small>
                                <small class="error" *ngIf="forgotPasswordForm.get('password')?.errors?.minlength" i18n="@@error.confirm_password_same_new_password">Password must be at least 6 characters long</small>
                            </div>
                        </div>
                        <div class="password_contaier">
                            <label for="confirmPassword" i18n="@@forgot.confirm_new_password">Confirm New Password</label>
                            <input formControlName="passwordConfirm" [type]="showPassword.confirmPassword ? 'text' : 'password'" id="confirmPassword" required />
                            <img class="eye-toggle eye-open" src="./images/signup/eye-open.png" loading="lazy" alt="Open eye" *ngIf="!showPassword.confirmPassword" (click)="togglePasswordVisibility('confirmPassword')">
                            <img class="eye-toggle eye-closed" src="./images/signup/eye-closed.png" loading="lazy" alt="Closed eye" *ngIf="showPassword.confirmPassword" (click)="togglePasswordVisibility('confirmPassword')">
                            <div *ngIf="forgotPasswordForm.get('passwordConfirm')?.dirty && forgotPasswordForm.get('passwordConfirm')?.errors">
                                <small class="error" *ngIf="forgotPasswordForm.get('passwordConfirm')?.errors?.required" i18n="@@error.required.confirm_password">Confirm password is required</small>
                                <small class="error" *ngIf="forgotPasswordForm.get('passwordConfirm')?.errors?.mismatch" i18n="@@error.confirm_password_same_new_password">Password and confirmation password must be the same</small>
                            </div>
                        </div>
                        
                        <button 
                            type="button" 
                            class="signUpBtn nextSignUpStep" 
                            [disabled]="!isFormValid()"
                            (click)="onSubmit()"
                            i18n="@@forgot.reset_password"
                        >
                            Reset password
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>